// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/***************** GET DAILY COLLECTION REPORT LIST START ************* */
export const dailyCollectionReportListGet = (listData: any) => {
	const data = {
		DailyCollectionReportToken: listData,
	};
	const url = `${API_URL}dailyCollectionReport`;
	return makeApiCall(url, data);
};
/***************** GET DAILY COLLECTION REPORT LIST START ************* */
